import moment from "moment";

/**
 * Calculates working seconds between two datetimes
 * (Mon–Sat, 9AM–6PM; Sunday excluded)
 */
function calculateWorkingSeconds(start, end) {
  let current = moment(start).clone();
  const endTime = moment(end);
  let totalSeconds = 0;

  while (current.isBefore(endTime)) {
    const day = current.isoWeekday(); // 1 = Mon ... 7 = Sun
    const hour = current.hour();

    if (day >= 1 && day <= 6 && hour >= 9 && hour < 18) {
      totalSeconds += 1; // add one second
    }

    current.add(1, "second");
  }

  return totalSeconds;
}

/**
 * Formats seconds into DD:HH:MM:SS
 */
function formatTime(seconds) {
  const isNegative = seconds < 0;
  seconds = Math.abs(seconds);

  const days = Math.floor(seconds / 86400);
  const hrs = Math.floor((seconds % 86400) / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  return `${isNegative ? "-" : ""}${String(days).padStart(2, "0")}:${String(
    hrs
  ).padStart(2, "0")}:${String(mins).padStart(2, "0")}:${String(secs).padStart(
    2,
    "0"
  )}`;
}

/**
 * type = 1 → working hours (Mon–Sat, 9AM–6PM)
 * type = 2 → full 24 hours
 */
function getTimeStatus(startDate, endDate, type = 2) {
  const start = moment(startDate);
  const end = moment(endDate);

  const limitInSeconds = type === 1 ? 18 * 60 * 60 : 24 * 60 * 60;

  const usedSeconds =
    type === 1
      ? calculateWorkingSeconds(start, end)
      : end.diff(start, "seconds");

  const diff = limitInSeconds - usedSeconds;

  return formatTime(diff);
}

export { getTimeStatus };
